import axios from "axios";
import apiClient from "../../../utils/clients/axios";
import apiClientWithoutToken from "../../../utils/clients/axiosWithoutToken";

export const GuestCreation = async (payload) => {
  const response = await apiClientWithoutToken.post("/guests/", payload, {});

  return response;
};

export const getGuestData = async () => {
  const { data } = await apiClient.get("/guests/in/?type=organization");

  console.log({ data });

  return data;
};

export const getRelationData = async () => {
  const { data } = await apiClient.get("/guests/in/?type=relationship");

  console.log({ data }, "relation");

  return data;
};

export const updateGuestStatus = async (id) => {
  console.log({ id });
  const response = await apiClient.patch(`/guests/out?id=${id}`, {
    status: "out",
  });

  return response;
};

export const getEmployeeDropdown = async () => {
  const { data } = await apiClientWithoutToken.get("/users");

  return data;
};

export const getEmployeeSuggestions = async () => {
  const { data } = await apiClient.get("/guests/suggestions");

  return data;
};
